<template>
  <div class="personal__favorite">
    <div v-if="moduleFavorites.favorites.length > 0" class="f-items">
      <div v-for="(item, index) in moduleFavorites.favorites" :key="index" class="f-item">
        <a class="f-item__title" :href="item.DETAIL_PAGE_URL">
          <div class="f-item__title-img" :class="{'filled':item.PREVIEW_PICTURE}">
            <img :src="item.PICTURE ? item.PICTURE : ''" alt="Изображение" loading="lazy">
          </div>
          <div class="f-item__title-item">{{ item.NAME }}</div>
        </a>
        <div class="f-item__price">
          <div class="f-item__price-current">{{ new Intl.NumberFormat("ru-RU").format(Number(item.PRICE)) }} ₽</div>
          <div v-if="item.BASE_PRICE" class="f-item__price-old">
            {{ new Intl.NumberFormat("ru-RU").format(Number(item.BASE_PRICE)) }} ₽
          </div>
        </div>
        <div v-if="item.AV_QUANTITY === '0' || !item.AV_QUANTITY" class="f-item__empty" >Нет в наличии</div>
        <favorites-buttons v-else :id="item.ID"></favorites-buttons>
        <div class="f-item__delete" @click="DEL_FAVS_ITEM(item.ID)"></div>
      </div>
    </div>
    <div v-else class="personal__favorite-empty">
      <p>Здесь будут Ваши избранные товары.</p>
    </div>
    <div class="f-btns">
      <a class="f-btns__item btn" href="/catalog/">Перейти в каталог</a>
      <a class="f-btns__item btn--white" href="/basket/">Перейти в корзину</a>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import errors                 from "@/components/mixins/errors";
import FavoritesButtons       from "@/components/Favorites/FavoritesButtons";

export default {
  name       : "BigFavorites",
  components : {FavoritesButtons},
  mixins     : {errors},
  computed   : {
    ...mapState([
      "moduleFavorites"
    ])
  },
  methods    : {
    ...mapActions([
      "DEL_FAVS_ITEM"
    ])
  }
};
</script>

<style scoped>

</style>